<template>
  <v-card class="pa-4">
    <v-row justify="end">
      <v-col cols="12" md="6">
        <v-text-field
          v-model="search"
          hide-details
          append-inner-icon="mdi-magnify"
          variant="underlined"
          label="Поиск"
          style="width: 100%"
        ></v-text-field>
        <div class="d-flex justify-end mt-4 mb-6">
          <v-btn color="primary" @click="openEditDialog()"
            >Добавить дисциплину
          </v-btn>
        </div>
      </v-col>
    </v-row>

    <v-data-table
      :headers="headers"
      :items="disciplines"
      :search="search"
      item-value="id"
      :loading="loading"
    >
      <template #item.actions="{ item }">
        <v-icon color="teal darken-1" class="me-2" @click="openEditDialog(item)"
          >mdi-pencil</v-icon
        >
        <v-icon
          color="red darken-3"
          class="me-2"
          @click="openDeleteDialog(item)"
          >mdi-delete
        </v-icon>
        <v-icon color="amber darken-1" @click="openInfoDialog(item)"
          >mdi-file-search
        </v-icon>
      </template>
    </v-data-table>
    <!-- Диалог редактирования -->
    <v-dialog v-model="editDialog" max-width="500px">
      <v-form @submit.prevent ref="myform">
        <v-card>
          <v-card-title class="text-h6">
            {{ editedItem.id ? "Редактировать" : "Добавить" }} дисциплину
          </v-card-title>
          <v-card-text>
            <v-text-field
              v-model="editedItem.name"
              label="Наименование"
              required
              :rules="[(v) => !!v || 'Обязательное поле']"
            ></v-text-field>

            <v-text-field
              v-model="editedItem.shortName"
              label="Краткое наименование"
              required
              :rules="[(v) => !!v || 'Обязательно поле']"
            ></v-text-field>

            <v-select
              v-model="editedItem.isMdk"
              :items="types"
              item-title="name"
              item-value="value"
              label="Тип"
              required
              :rules="[(v) => !!v || 'Обязательное поле']"
            ></v-select>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="editDialog = false">Отмена</v-btn>
            <v-btn color="primary" @click="saveDiscipline">Сохранить</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <!-- Диалог подтверждения удаления -->
    <v-dialog v-model="deleteDialog" max-width="400px">
      <v-card>
        <v-card-title class="text-h6">Подтверждение удаления</v-card-title>
        <v-card-text>
          Вы уверены, что хотите удалить дисциплину
          <strong>{{ selectedItem?.name }}</strong
          >?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="deleteDialog = false">Отмена</v-btn>
          <v-btn color="red" @click="deleteDiscipline">Удалить</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Диалог просмотра информации -->
    <v-dialog v-model="infoDialog" max-width="700px">
      <v-card>
        <v-card-title class="text-h6">Информация о дисциплине</v-card-title>
        <v-card-text v-if="selectedItem">
          <p><strong>Наименование:</strong> {{ selectedItem.name }}</p>
          <v-list>
            <v-list-item v-for="(disc, i) in discInPlan" :key="i">
              <v-list-item-title>
                <a
                  :href="
                    this.$model.wwwroot +
                    '/blocks/manage_groups/plan2/index.php?c=EditPlans/edit&id=' +
                    disc.plan_id
                  "
                  target="_blank"
                >
                  Учебный план специальности {{ disc.code_specialty }}
                  {{ disc.year }} : Индекс {{ disc.index }}
                </a>
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="infoDialog = false"
            style="position: fixed; bottom: 0"
            >Закрыть</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Snackbar -->
    <v-snackbar v-model="snackbar" color="red-accent-2"  location="center" timeout="3500">
      {{ snackbarMessage }}
    </v-snackbar>

    <v-overlay v-model="processData" persistent class="align-center justify-center">
      <v-progress-circular
        color="primary"
        size="64"
        indeterminate
      ></v-progress-circular>
    </v-overlay>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      search: "",
      disciplines: [],
      types: [],
      headers: [
        { title: "#", value: "num" },
        { title: "Наименование", value: "name" },
        { title: "Краткое наименование", value: "shortName" },
        { title: "Тип", value: "isMdk" },

        {
          title: "Действия",
          value: "actions",
          width: "160px",
          sortable: false,
        },
      ],
      editDialog: false,
      deleteDialog: false,
      infoDialog: false,
      snackbar: false,
      snackbarMessage: "",
      editedItem: {
        id: null,
        name: "",
        shortName: "",
        isMdk: null,
      },
      selectedItem: null,
      loading: true,
      processData: false,
      discInPlan: [],
    };
  },
  created() {
    this.fetchDisciplines();
  },
  methods: {
    fetchDisciplines() {
      this.axios
        .post(
          this.$model.wwwroot +
            "/procollege/manage_groups/plan3/disciplines/getDisciplines"
        )
        .then((resp) => {
          let k = 1;
          for (let i in resp.data.disciplines) {
            this.disciplines.push({
              num: k++,
              name: resp.data.disciplines[i].name,
              shortName: resp.data.disciplines[i].shortname,
              isMdk: resp.data.disciplines[i].is_mdk,
              id: resp.data.disciplines[i].id,
            });
          }
          this.types = resp.data.types;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    openEditDialog(item = null) {
      this.editedItem = item
        ? { ...item }
        : {
            id: null,
            name: "",
            shortName: "",
            isMdk: null,
          };
      this.editDialog = true;
    },
    openDeleteDialog(item) {
      this.selectedItem = item;
      this.deleteDialog = true;
    },
    deleteDiscipline() {
      const index = this.disciplines.findIndex((d) => d.id === this.selectedItem.id);
      this.processData = true;
      this.axios
        .post(
          this.$model.wwwroot +
            "/procollege/manage_groups/plan3/disciplines/deleteDiscipline",
          new URLSearchParams({
            id: this.selectedItem.id,
          })
        )
        .then((response) => {
          if (response.data) {
            this.disciplines.splice(index, 1);
          } else {
            this.snackbarMessage =
              "Удалить дисциплину не получится, т.к. она участвует в учебном плане";
            this.snackbar = true;
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.deleteDialog = false;
          this.processData = false;
        });
    },
    openInfoDialog(item) {
      this.selectedItem = item;
      this.getDiscInPlan();
    },
    async saveDiscipline() {
      let valid = await this.$refs.myform.validate();
      if (!valid.valid) {
        return;
      }
      this.processData = true;
      const index = this.disciplines.findIndex(
        (d) => d.id === this.editedItem.id
      );
      
      this.axios
        .post(
          this.$model.wwwroot +
            "/procollege/manage_groups/plan3/disciplines/saveDisciplines",
          new URLSearchParams({
            id: this.editedItem.id,
            name: this.editedItem.name,
            short_name: this.editedItem.shortName,
            is_mdk: this.types.indexOf(this.editedItem.isMdk),
          })
        )
        .then((response) => {
          if (index !== -1) {
            this.disciplines[index] = this.editedItem;
          } else {
            const newItem = {
              ...this.editedItem,
              id: response.data,
              num: this.disciplines.length + 1,
            };
            this.disciplines.push(newItem);
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.editDialog = false;
          this.processData = false;
        });
    },
    getDiscInPlan() {
      this.processData = true;
      this.axios
        .post(
          this.$model.wwwroot +
            "/procollege/manage_groups/plan3/disciplines/getDiscInPlan",
          new URLSearchParams({
            id: this.selectedItem.id,
          })
        )
        .then((response) => {
          this.discInPlan = response.data;
          this.processData = false;
          this.infoDialog = true;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>